import { classNames } from '@fullstory/util/fmt';
import React, { useContext } from 'react';
import { identifyComponent } from '../../util';
import { Icon } from '../Icon';
import { CollapsibleSectionContext } from './Context';
import css from './index.module.scss';

interface CollapsibleSectionIconProps
  extends Pick<React.ComponentProps<typeof Icon>, 'size' | 'color'> {}

export const CollapsibleSectionIcon: React.FunctionComponent<
  CollapsibleSectionIconProps
> = props => {
  const { collapsed } = useContext(CollapsibleSectionContext);
  return (
    <div
      data-component="CollapsibleSectionIcon"
      aria-hidden
      className={classNames(css.iconWrapper, { [css.expanded]: !collapsed })}
      {...identifyComponent('collapsible-section-icon')}
    >
      <Icon name="chevron-right" {...props} />
    </div>
  );
};
